
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.197 5.762c.412.42.68.976.803 1.667h-6.286V1c.675.126 1.219.4 1.63.82l3.853 3.942zM12.2 9.279H19v10.35c0 .344-.117.637-.35.88a1.138 1.138 0 01-.85.361H4.2c-.333 0-.617-.12-.85-.362a1.219 1.219 0 01-.35-.88V2.242c0-.345.117-.638.35-.88.233-.241.517-.362.85-.362H11v7.037c0 .345.117.639.35.88.233.241.517.362.85.362z","fill":"#191737","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_file.svg